export class UpdatePaymentInfoRequest {
    companyId: string;
    paymentType: number;

    cardNumber: string;
    cardExpiration: string;
    cvv: string;
    billingAddress: string;
    city: string;
    state: string;
    zip: string;

    routingNumber: string;
    accountNumber1: string;
    accountNumber2: string;
    nameOnAccount: string;
}